<template>
  <div class="d-flex flex-column align-items-stretch hover-target">
    <div class="d-flex flex-row w-100">
      <ListThumbnail
        v-if="license.city?.imageCachingEnabled"
        :src="license.thumbnailUrl"
        :fallback-src="license.imageUrl"
        class="me-2"
      />
      <BImage v-else-if="license.imageUrl" :src="license.imageUrl" image-class="rounded me-2" />
      <div class="d-flex flex-column align-items-stretch flex-grow-1">
        <!-- Row 1: Address + Status -->
        <div class="d-flex flex-row align-items-center">
          <div class="fw-semibold me-auto">
            {{ normalizedAddress }}
          </div>
          <LicenseStatusView :license="license" class="ms-2 small" />
        </div>

        <div v-if="!license.isLinkedToProperty" class="text-danger small">
          <i class="bi-info-circle" /> Unknown parcel ID
        </div>

        <!-- Row 2: License # + Date -->
        <div class="d-flex flex-row align-items-center small">
          <div class="me-auto text-muted d-flex flex-row flex-wrap gap-0">
            <div v-if="license.number">License #{{ license.number }}</div>
            <template v-if="license.licenseTypeLabel">
              <i class="bi-dot"/>
              <div>{{ license.licenseTypeLabel }}</div>
            </template>
            <template v-for="field in customFields" :key="field.id">
              <template v-if="license.getCustomFieldValue(field.id)">
                <i class="bi-dot"/>
                <div>
                  {{ license.getCustomFieldValue(field.id) }}
                </div>
              </template>
            </template>
          </div>
          <LicenseDateView :license="license" class="text-muted" />
        </div>

        <!-- Row 3: Contact -->
        <div v-if="isAuthenticated && license.contact && license.contact.owners" class="d-flex flex-row align-items-start small">
          <div class="me-auto text-muted">{{ license.contact.owners.map(formatDisplayName).join(', ') }}</div>
          <div v-if="!license.isExpired && license.expirationDateFormatted" class="text-nowrap text-muted">
            Expires {{ license.expirationDateFormatted }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {License} from "@/models/License";
import ListThumbnail from "@/components/common/ListThumbnail.vue";
import BImage from "@/components/common/BImage.vue";
import LicenseStatusView from "@/components/LicenseStatusView.vue";
import LicenseDateView from "@/components/LicenseDateView.vue";
import {Session} from "@/models/User";
import { normalizeAddressLines } from "@/addressFormatting";
import {formatDisplayName} from "@/nameFormatting";

export default {
  methods: {formatDisplayName},
  components: {
    LicenseDateView,
    LicenseStatusView,
    ListThumbnail,
    BImage
  },
  props: {
    license: License
  },
  computed: {
    isAuthenticated() {
      return Boolean(Session.currentUser.value);
    },
    city() {
      return this.license.city;
    },
    customFields() {
      return this.city?.customFields?.filter(field => field.filter) || [];
    },
    normalizedAddress() {
      const rawAddress = this.license.addressFormatted || this.license.unverifiedAddress;
      const [line1] = normalizeAddressLines(rawAddress);
      return line1 || rawAddress || 'Unknown address';
    }
  }
}
</script>
